document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('ul.media-gallery__grid');
  if (!gallery) return;

  const items = gallery.querySelectorAll('li.product-media-container');
  if (items.length <= 6) return;

  const hiddenCount = items.length - 6;
  const btn = document.createElement('button');
  btn.id = 'show-more-media-btn';
  btn.textContent = 'Zobacz więcej zdjęć (' + hiddenCount + ')';
  gallery.insertAdjacentElement('afterend', btn);

  btn.addEventListener('click', function () {
    if (gallery.classList.contains('show-all')) {
      gallery.classList.remove('show-all');
      btn.textContent = 'Zobacz więcej zdjęć (' + hiddenCount + ')';
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      gallery.classList.add('show-all');
      btn.textContent = 'Pokaż mniej';
    }
  });
});
